import { render, staticRenderFns } from "./TriggerBlock.vue?vue&type=template&id=15a18cc2&"
import script from "./TriggerBlock.vue?vue&type=script&lang=ts&"
export * from "./TriggerBlock.vue?vue&type=script&lang=ts&"
import style0 from "./TriggerBlock.vue?vue&type=style&index=0&id=15a18cc2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../home/bearlogin/development/pinq-project/mono2/client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports